__turbopack_context__.v({
  "badge": "event-section-module__h4WwRW__badge",
  "badgeImg": "event-section-module__h4WwRW__badgeImg",
  "empty": "event-section-module__h4WwRW__empty",
  "emptyIcon": "event-section-module__h4WwRW__emptyIcon",
  "emptyText": "event-section-module__h4WwRW__emptyText",
  "eventSwiper": "event-section-module__h4WwRW__eventSwiper",
  "headerActions": "event-section-module__h4WwRW__headerActions",
  "headerTitleWrap": "event-section-module__h4WwRW__headerTitleWrap",
  "sectionHeader": "event-section-module__h4WwRW__sectionHeader",
  "seeAllLink": "event-section-module__h4WwRW__seeAllLink",
  "skeletonSlide": "event-section-module__h4WwRW__skeletonSlide",
  "title": "event-section-module__h4WwRW__title",
});
